import React from "react";
import { Box, Tabs, Tab, SxProps, Theme } from "@mui/material";

interface TabItem {
  label: string;
  content: React.ReactNode;
}

interface CustomTabsProps {
  tabs: TabItem[];
  activeTab: number;
  onChange: (index: number) => void;
  sx?: SxProps<Theme>;
}

const CustomTabs: React.FC<CustomTabsProps> = ({
  tabs,
  activeTab,
  onChange,
  sx,
}) => {
  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    onChange(newValue);
  };

  return (
    <Box>
      <Tabs
        value={activeTab}
        onChange={handleChange}
        aria-label="custom-tabs"
        sx={{
          "& .MuiTabs-indicator": {
            backgroundColor: "rgba(81, 82, 92, 1)",
            height: "2px",
          },
          "& .MuiTab-root": {
            textTransform: "none",
            fontWeight: 600,
            minWidth: "auto",
            padding: "0 60px",
            color: "rgba(113, 118, 128, 1)",
          },
          "& .Mui-selected": {
            color: "black",
          },
          ...sx,
        }}
      >
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            label={<Box>{tab.label ?? "N/A"}</Box>}
            aria-controls={`tabpanel-${index}`}
            id={`tab-${index}`}
          />
        ))}
      </Tabs>
      <Box mt={2} role="tabpanel" aria-labelledby={`tab-${activeTab}`}>
        {tabs[activeTab]?.content || "No content available"}
      </Box>
    </Box>
  );
};

export default CustomTabs;
